import { ERole } from '~/constants/enum'
import Ranks from '~/constants/ranks'

export function textRankClass(rank: string) {
  const txtRankClass =
    {
      junior: 'text-cyan-500',
      middle: 'text-amber-500',
      senior: 'text-pink-500',
      expert: 'text-secondary-500',
    }[rank] || 'text-[#908F8F]'

  return `${txtRankClass}`
}

export function buttonUpgradeClass(rank: string) {
  const btnUpgradeClass =
    {
      junior: 'text-cyan-500 bg-cyan-100 border-cyan-500 after:bg-cyan-200',
      middle: 'text-amber-500 bg-amber-100 border-amber-500 after:bg-amber-200',
      senior: 'text-pink-500 bg-pink-100 border-pink-500 after:bg-pink-200',
      expert:
        'text-secondary-500 bg-secondary-100 border-secondary-500 after:bg-secondary-200',
    }[rank] || 'text-[#908F8F]'

  return `${btnUpgradeClass}`
}

export function tagHeaderClass(rank: string) {
  const tagClass =
    {
      entry: 'bg-neutral-500',
      junior: 'bg-cyan-500',
      middle: 'bg-amber-500',
      senior: 'bg-pink-500',
      expert: 'bg-secondary-500',
    }[rank] || 'bg-neutral-400'

  return `${tagClass}`
}

export function getTagHeaderBorderTopClass(rank: string) {
  const tagClass =
    {
      entry: 'border-t-neutral-500',
      junior: 'border-t-cyan-500',
      middle: 'border-t-amber-500',
      senior: 'border-t-pink-500',
      expert: 'border-t-secondary-500',
    }[rank] || 'border-t-neutral-400'

  return `${tagClass}`
}

export function getRingColorInterviewItem(rank: string) {
  const tagClass =
    {
      entry: 'hover:ring-neutral-500',
      junior: 'hover:ring-cyan-500',
      middle: 'hover:ring-amber-600',
      senior: 'hover:ring-pink-600',
      expert: 'hover:ring-secondary-600',
    }[rank] || 'hover:ring-neutral-500'

  return `${tagClass}`
}

export function buttonColorByRank(rank: string, isShowImage: boolean) {
  if (isShowImage) {
    return 'white'
  } else {
    switch (rank) {
      case Ranks.Entry:
        return 'neutral'
      case Ranks.Junior:
        return 'info'
      case Ranks.Middle:
        return 'warning'
      case Ranks.Senior:
        return 'error'
      default:
        return 'secondary'
    }
  }
}

export function textColorByRank(rank: string) {
  switch (rank) {
    case Ranks.Entry:
      return 'text-neutral-500'
    case Ranks.Junior:
      return 'text-cyan-500'
    case Ranks.Middle:
      return 'text-amber-500'
    case Ranks.Senior:
      return 'text-pink-500'
    default:
      return 'text-secondary-500'
  }
}

export function isHiddenBlurQuestionFunc(roles) {
  const allowedRoles = [
    ERole.Gold,
    ERole.Diamond,
    ERole.Admin,
    ERole.SuperAdmin,
  ]

  return allowedRoles.some((role) => roles.includes(role))
}
